import { combineReducers } from 'redux';

import logIn from './log-in';

const rootReducer = combineReducers({
  logIn,
});

export default rootReducer;
